import axios from 'axios'

export default axios.create({
  // baseURL: 'https://nagorka.ci-cms.pp.ua/api/',
  // baseURL: 'https://nagorniy.com.ua/api/',
  baseURL: window.location.origin + '/api/',
})